<script setup lang="ts">
import { ELocalStorageKeys } from '~/features/store/ELocalStorageKeys';
import { ButtonSecondaryNeutral } from '@/features/ui-kit';
import { MMText } from '@mm-frontend/mm-web-ui-kit';
import { useLocalStorage } from '@vueuse/core';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
const route = useRoute();

const POLICY_HREF = 'https://legal.mm.ru/#rec748057637';

const isCookieAccepted = useLocalStorage(ELocalStorageKeys.MM__IS_COOKIE_ACCEPTED, false);
const isShown = computed(() => !isCookieAccepted.value && !route.meta.hidePromoPopup);

const onConfirm = () => (isCookieAccepted.value = true);
</script>

<template>
  <div class="cookie-accept-popup-wrapper" v-if="isShown" :style="{ bottom: `10px` }">
    <div class="cookie-accept-popup">
      <MMText
        font="Body L/Medium"
        font-mobile-or-tablet="Body M/Medium Long"
        color="inverse-primary"
      >
        Мы используем файлы cookie
      </MMText>

      <MMText font="Body M/Regular" font-mobile-or-tablet="Body S/Regular" color="inverse-primary">
        Так сайт работает стабильнее, а входить в профиль повторно не нужно.
        <br />
        <a :href="POLICY_HREF" target="_blank" class="cookie-accept-popup__link"
          >Подробнее в Политике</a
        >
      </MMText>
      <ButtonSecondaryNeutral w100 @click.native="onConfirm">Хорошо</ButtonSecondaryNeutral>
    </div>
  </div>
</template>

<style scoped lang="stylus">
.cookie-accept-popup-wrapper
  position fixed
  z-index 9999
  right 32px
  +Media(Mobile, Tablet)
    left 16px
    right 16px


.cookie-accept-popup
  position relative
  padding 16px
  border-radius 16px
  background-color var(--background-popover-inverted)
  width 360px
  display flex
  flex-direction column
  gap 8px
  +Media(Mobile, Tablet)
    width unset
    padding 12px
    border-radius 12px

  &__link
    color inherit
    text-decoration underline
    cursor pointer

  &__close
    position absolute
    top 16px
    right 16px
    cursor pointer
    +Media(Mobile, Tablet)
      top 12px
      right 12px
</style>
